module.exports = __webpack_public_path__ + "ejemploa2.png?b1c7ccbb0839897d3c77b1630af9299b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ejemploa2.png
// module id = 789
// module chunks = 2